import { useState } from "react";
import { soulApi } from "../../data/api/SoulApi";
import { soulManager } from "../../data/managers/SoulManager";
import { SoulDataModel, UpdateSoulInfoPayload } from "../../data/models/Soul/SoulDataModel";

async function createNewUser({
  fullName,
  phoneNumber,
}: {
  fullName: string;
  phoneNumber: string;
}) {
  return soulApi.createUserAsAdmin.request({
    userData: { fullName, phoneNumber },
  });
}

export function useCreateUser() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createUser = async (params: {
    fullName: string;
    phone: string;
    documentType?: string;
    document?: string;
    birthDate?: string;
    emailOptional?: string;
    address?: string;
    isVerified?: boolean;
    isGuarantor?: boolean;
  }) => {
    try {
      setIsLoading(true);
      setError(null);

      // Paso 1: crear usuario
      const result = await createNewUser({
        fullName: params.fullName,
        phoneNumber: params.phone,
      });
      if (!result.isSuccess) {
        throw new Error(result?.message || "Error creando usuario");
      }

      // Paso 2: actualizar perfil con campos adicionales
      const userId = (result.data as any)?.uid;
      if (userId && (params.document || params.birthDate)) {
        const soulData = new SoulDataModel({
          userId,
          fullName: params.fullName,
          documentType: params.documentType as any,
          document: params.document,
          birthDate: params.birthDate,
          emailOptional: params.emailOptional || null,
          address: params.address || null,
          isVerified: params.isVerified ?? false,
          isGuarantor: params.isGuarantor ?? false,
          role: "USER",
        } as any);
        const payload = new UpdateSoulInfoPayload(soulData);
        await soulManager.updateSoulInfoByAdmin(payload);
      }

      return true;
    } catch (err: any) {
      setError(err.message ?? "Error desconocido");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { createUser, isLoading, error };
}
